import {Base}                                          from "./base";
import {forwardRef, HTMLAttributes, PropsWithChildren} from "react";


type PageTitleProps = HTMLAttributes<HTMLHeadingElement> & {
  as?: any;
  light?: boolean;
}

export const TitleSmall = forwardRef<any, PropsWithChildren<PageTitleProps>>((props, ref) => {
  return <Base
    as={props.as || "h2"}
    {...props}
    size={5}
    weight={500}
    ref={ref}
    className={props.className}
  >{props.children}</Base>;
});

